import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL

const api = axios.create({
  baseURL: baseUrl,
});

const onRequest = async (apiConfig) => {
  let tokens = JSON.parse(localStorage.getItem("challanTokens"));

  let accessToken = tokens?.access_token;
  let accessExpiresAt = tokens?.expires;

  //let refreshToken = tokens?.refresh_token;

  if (accessToken) {
    if (accessExpiresAt && new Date(accessExpiresAt) < new Date()) {
      window.location["pathname"] = "/signin";
    }
    apiConfig.headers.Authorization = "Bearer " + accessToken;
  }

  return apiConfig;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  return Promise.reject(error);
};

api.interceptors.request.use(onRequest, onRequestError);
api.interceptors.response.use(onResponse, onResponseError);

export default api;
